import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components';
import { useMediaQuery } from '@/shared/lib';
import type {
  OperationFilter,
  OperationHistoryFilterItem,
} from '@/shared/types';
import { tv } from 'tailwind-variants';

type Props = {
  onValueChange: (value: OperationFilter) => void;
  value: OperationFilter;
  options: OperationHistoryFilterItem[];
};

const classes = tv({
  slots: {
    filters: 'flex gap-[1.6rem]',
    button: 'w-auto h-[4.2rem] rounded-[2.4rem] hover:bg-white',
    selectTrigger:
      'headline4 hover:bg-stroke w-auto max-h-[4.2rem] h-[4.2rem] rounded-full bg-white pt-[1.6rem] pr-[1.2rem] pb-[1.6rem] pl-[1.2rem] cursor-pointer',
    selectContent: 'min-w-[34.2rem] bg-white rounded-[1.6rem]',
    selectContentViewport: 'min-w-[34.2rem]',
    selectItem: 'py-[1.6rem] pl-[2.4rem] pr-[4.8rem] w-full',
    selectItemTitle: 'headline4 w-full',
  },
  variants: {
    isActive: {
      true: { button: 'bg-white' },
      false: { button: 'bg-stroke-bg' },
    },
  },
  defaultVariants: {
    isActive: false,
  },
});

export const HistoryOperationTypeSelect = ({
  onValueChange,
  value,
  options,
}: Props) => {
  const isTablet = useMediaQuery('(max-width: 1336px)');
  const c = classes();

  return isTablet ? (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger withChevron size="md" className={c.selectTrigger()}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent
        className={c.selectContent()}
        classNameViewport={c.selectContentViewport()}>
        {options.map(({ name, filter }) => (
          <SelectItem key={filter} value={filter} className={c.selectItem()}>
            <span className={c.selectItemTitle()}>{name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  ) : (
    <div className={c.filters()}>
      {options.map(({ name, filter }) => (
        <Button
          key={filter}
          className={c.button({ isActive: value === filter })}
          variant="secondary"
          size="lg"
          onClick={() => onValueChange(filter)}>
          {name}
        </Button>
      ))}
    </div>
  );
};
